import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { LoadProjects } from '../model/project';
import { select, Store } from '@ngrx/store';
import { AppState } from '../model/reducer';
import { canCreateInventoryView, canCreateProjectView } from '../model/views/permission.views';
import { Observable } from 'rxjs';
import { Project } from '../projects/project.model';
import { allInventoriesView, allProjectsView } from '../model/views';
import _ from 'lodash';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Inventory } from '../inventory/inventory.model';



@Component({
    selector: 'adm4-welcome',
    template: `
    <div class='full-height-flex'>
      <adm4-column-header styleClass="welcome-header">
        <adm4-welcome-header></adm4-welcome-header>
      </adm4-column-header>
      <div class='remaining-space-flex-content-wrapper'>
        <div class='welcome-container remaining-space-flex-content'>
          @switch (mode|async) {
            @case (INVENTORY_MODE) {
              <adm4-welcome-inventory-content [canCreateInventory]='canCreateInventory$ | async' [projects]='projects$ | async'></adm4-welcome-inventory-content>
            }
            @default {
              <adm4-welcome-content [canCreateProject]='canCreateProject$ | async' [projects]='projects$ | async'></adm4-welcome-content>
            }
          }
        </div>
      </div>
    </div>
    `,
    styleUrls: ['./welcome.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WelcomeComponent implements OnInit {
  private store$ = inject<Store<AppState>>(Store);
  activatedRoute = inject(ActivatedRoute);


  canCreateProject$: Observable<boolean>;
  projects$: Observable<Project[]>;
  mode: Observable<'inventory' | 'project'>;
  canCreateInventory$: Observable<boolean>;
  inventories$: Observable<Inventory[]>;
  INVENTORY_MODE = 'inventory';

  constructor() {

    this.mode = this.activatedRoute.data.pipe(map(value => {
      return _.isNil(value) || value.mode === this.INVENTORY_MODE ? value.mode : 'project';
    }));

    this.canCreateProject$ = this.store$.pipe(select(canCreateProjectView));
    this.canCreateInventory$ = this.store$.pipe(select(canCreateInventoryView));
    this.projects$ = this.store$.pipe(select(allProjectsView),  map(_.values));
    this.inventories$ = this.store$.pipe(select(allInventoriesView),  map(_.values));
  }

  ngOnInit(): void {
    this.store$.dispatch(new LoadProjects());
  }
}
